import React from 'react';
import { Button } from 'ui';
import { routes } from 'constants/config';
import { setQueryString } from 'utils/url';

const EVENT_NAME_COPY_TEXT_OFFSET = 7;
const EVENT_NAME_TRUNCATION_THRESHOLD = 255 - EVENT_NAME_COPY_TEXT_OFFSET;

const Copy = ({ event }) => {
  let eventName = event.name;
  if (eventName.length > EVENT_NAME_TRUNCATION_THRESHOLD) {
    eventName = eventName.slice(
      0,
      eventName.length - EVENT_NAME_COPY_TEXT_OFFSET,
    );
  }

  const params = {
    eventName: t('in_person_training.new_event.copied_name', {
      name: eventName,
    }),
    eventDescription: event.description,
    eventParentId: event.id,
  };
  return (
    <>
      <Button
        icon="copy"
        className="mr-12 trk_button_learning_copy-event"
        url={setQueryString(routes.IN_PERSON_TRAINING.NEW_EVENT, params)}
        small
        fullWidth
      >
        {t('common.copy')}
      </Button>
    </>
  );
};

export default Copy;
